import type { SubmitError } from './types';

export const ERROR_MESSAGES: Record<NonNullable<SubmitError>, string> = {
  captcha: "We couldn't verify you're not a robot. Please try again.",
  ticket: 'There was an unexpected error processing your request, please try again.',
  validation: 'There were problems with the form. Please see below for more details.',
};

/** How long the success message stays up before the form comes back, in ms. */
export const RESET_TIMEOUT = 10_000;
